module.exports = __webpack_public_path__ + "files/0707070af1dc7047c02284009a667e27.png";